import React, { FC } from 'react'
import { Layout } from 'components/Layout'
import { ExportDeliveryOrderTemplate } from 'components/Templates'

const ExportDeliveryOrder: FC = () => {
  return (
    <Layout
      headline={'送り状CSV出力'}
      iconPath={'/icon/white/schedule.svg'}
      headlineSize={'small'}
      title={'送り状CSV出力'}
    >
      <ExportDeliveryOrderTemplate />
    </Layout>
  )
}

export default ExportDeliveryOrder
